import { MasterActions, MasterInitialState } from "./../actions/Master";

export const MasterReducer = (state = MasterInitialState, actions) => {
  switch (actions.type) {
    case MasterActions.GET_JENIS_LAYANAN:
      return {
        ...state,
        jenis_layanan: actions.payload,
      };
    case MasterActions.GET_ALL_JENIS_LAYANAN:
      return {
        ...state,
        all_jenis_layanan: actions.payload,
      };
    case MasterActions.GET_ASURANSI:
      return {
        ...state,
        asuransi: actions.payload,
      };
    case MasterActions.GET_PERUSAHAAN:
      return {
        ...state,
        perusahaan: actions.payload,
      };
    case MasterActions.GET_SPESIALIS:
      return {
        ...state,
        spesialis: actions.payload,
      };
    case MasterActions.GET_RUANG:
      return {
        ...state,
        ruang: actions.payload,
      };
    case MasterActions.GET_POLIKLINIK:
      return {
        ...state,
        poliklinik: actions.payload,
      };
    case MasterActions.GET_DOKTER:
      return {
        ...state,
        dokter: actions.payload,
      };
    case MasterActions.GET_KELAS_KUNJUNGAN:
      return {
        ...state,
        kelas_kunjungan: actions.payload,
      };
    case MasterActions.GET_KELAS_KAMAR:
      return {
        ...state,
        kelas_kamar: actions.payload,
      };
    case MasterActions.GET_GUDANG_PENJUALAN:
      return {
        ...state,
        gudangPenjualan: actions.payload,
      };
    case MasterActions.GET_ACCESS_FA:
      return {
        ...state,
        access_fa: actions.payload,
      };
    case MasterActions.GET_SETTING_RS:
      return {
        ...state,
        setting: actions.payload,
      };
    default:
    return state;
  }
};
